module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"bestSelling":"Le più vendute","collections":"Collections"},"en":{"bestSelling":"Most popular","collections":"Collections"}}')
  delete Component.options._Ctor
}
